import i18next from 'i18next';
import { carregarSelect2 } from './carregarSelect2';
import { CURRICULO_COLABORADOR, _URL_FORM, abrirFormCadastro, btnAcoesItensCurriculo, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';
import { uploadArquivo } from './uploads';

export const idiomas = function () {
    "use strict";
    var _excluir = function (id) {
        swal({
            title: i18next.t('idiomaRemoverTitle'),
            html: i18next.t('idiomaRemoverDesc'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show('#panel-idioma');

            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteIdioma?id=' + id, cache: false,
                success: function (data) {
                    if (data.success == 1) {
                        body.find('#idioma-item-' + id).remove();
                        toastr.success(i18next.t('idiomaRemoverSucesso'), '', { "closeButton": true });
                        progressoCurriculo();
                        _listar();
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderPanel.hide('#panel-idioma');
                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-idioma');
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    var _listar = function () {
        var panel = body.find('#panel-idioma');
        window.global.loaderPanel.show('#panel-idioma');

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetIdiomas', cache: false,
            success: function (dados) {
                var dadosLength = dados.length, html = [], item = '';
                var elementNull = document.getElementById("idioma-null");

                if (dadosLength > 0) {
                    elementNull.className = 'hide';
                    for (var i = 0; i < dadosLength; i++) {
                        item = '<li class="list-group-item" id="idioma-item-' + dados[i].ID + '" data-idioma="' + dados[i].IdiomaID + '" data-nivel="' + dados[i].Nivel + '" data-certificado="' + dados[i].certificado + '">' + btnAcoesItensCurriculo(dados[i].ID);
                        item += '<h4 class="nomargin"><b>' + dados[i].Nome + '</b></h4>';
                        item += '<p><b>' + dados[i].NivelString + '</b></p>';
                        if (!isNullOrEmpty(dados[i].certificado)) {
                            item += '<p><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + dados[i].certificado + '&nome=Certificado" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i> ' + i18next.t('downloadCertificado') + '</a></p>';
                        }
                        if (!isNullOrEmpty(dados[i].Descricao)) {
                            item += '<p class="idioma-descricao">' + dados[i].Descricao + '</p>';
                        }
                        item += '</li>';
                        html.push(item);
                    }
                    document.getElementById('idioma-lista').innerHTML = html.join('');
                    panel.find('.btn-excluir').on('click', function () {
                        var id = $(this).attr('data-id');
                        _excluir(id);
                    });
                    panel.find('.btn-editar').on('click', function () {
                        var id = $(this).attr('data-id');
                        _abrir(id);
                    });

                    panel.find('.btn-add').removeClass('hide');

                } else {
                    elementNull.className = '';
                }
                window.global.loaderPanel.hide('#panel-idioma');

            },
            error: function () {
                window.global.loaderPanel.hide('#panel-idioma');
            }
        });
    };
    var _salvar = function () {
        var content = body.find('#form-idioma');

        var id = content.find('#idioma-id').val();
        var nome = content.find('#idioma-idioma').val();
        var nivel = content.find('#idioma-nivel').val();
        var descricao = content.find('#idioma-descricao').val();
        var certificado = content.find('#IdiomaAnexoCertificado').val();

        // impede idioma duplicado: mesmo idioma ja na lista (ignora o proprio item em edicao)
        var idiomaDuplicado = body.find('#idioma-lista .list-group-item').filter(function () {
            return $(this).attr('data-idioma') === nome && $(this).attr('id') !== ('idioma-item-' + id);
        }).length > 0;
        if (idiomaDuplicado) {
            toastr.error(i18next.t('idiomaDuplicado'), '', { "closeButton": true });
            return;
        }

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveIdioma', cache: false,
            data: {
                ID: id,
                IdiomaID: nome,
                Nivel: nivel,
                Descricao: descricao,
                AnexoCertificado: certificado
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('idiomaSalvoSucesso'), '', { "closeButton": true });
                    if (id == 0) {
                        swal({
                            title: i18next.t('idiomaSalvoOutroTitle'),
                            html: i18next.t('idiomaSalvoOutroDesc'),
                            type: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#40afdf",
                            confirmButtonText: i18next.t('idiomaSalvoOutroAdd'),
                            cancelButtonText: i18next.t('btnNaoPossuo'),
                            closeOnConfirm: true
                        }, function (isConfirm) {
                            if (isConfirm) {
                                _abrir(0);
                            }
                        });
                    }

                    _listar();
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('idioma-contentform').innerHTML = '';
        goToByScroll('#panel-idioma');
        fecharFormCadastro();
    };
    var _abrir = function (id) {
        goToByScroll('#panel-idioma');

        window.global.loaderFull.show();
        // window.global.loaderPanel.show('#panel-idioma');
        var formulario = body.find('#idioma-contentform');
        var dataCargo = {};
        var colaborador = CURRICULO_COLABORADOR();
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Idioma?v=3", function () {
            $.validate({
                form: '#form-idioma'
            });
            formulario.find('#idioma-descricao').restrictLength($('#maxlengthIdiomaDescricao'));

            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-idioma').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });

            carregarSelect2().then(function () { formulario.find('#idioma-idioma').select2(); });
            if (colaborador) {
                formulario.find('.idioma-upload').on('click', function (e) {
                    var $this = $(this);
                    uploadArquivo.abrir($this.attr('data-id'), $this.attr('data-titulo'));

                    e.preventDefault();
                });
            } else {
                formulario.find('#box-IdiomaAnexoCertificado').addClass('hide');
            }
            if (id > 0) {
                var item = body.find('#idioma-item-' + id);
                formulario.find('#title-box').html('<i class=\"fa fa-edit mr5\"></i> ' + i18next.t('idiomaEditar'));
                formulario.find('#idioma-idioma').val(item.attr('data-idioma')).trigger("change");
                formulario.find('#idioma-nivel').val(item.attr('data-nivel'));
                formulario.find('#idioma-descricao').val(item.find('.idioma-descricao').html());
                formulario.find('#idioma-id').val(id);

                if (!isNullOrEmpty(item.attr('data-certificado'))) {
                    uploadArquivo.templateArquivo('Certificado', item.attr('data-certificado'), 'IdiomaAnexoCertificado', false);
                }

            }
            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide('#panel-idioma');
        });


    };

    var init = function () {
        _listar();

        body.find('#panel-idioma').find('.btn-add').on('click', function (e) {
            _abrir(0);
            e.preventDefault();
        });
    }

    return init();
};

